const LIMIT = 25

export default {
  LIMIT
}